import { MUSCLE_COMBINATIONS } from '../../constants'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'
import { intersectionArrayUtil } from 'packages/src'

const MIN_MUSCLE_INTERSECTION_RATIO = 0.05

/**
 * @param props
 * @param props.muscles
 * @param props.shouldNotDefaultToFullBody
 * @returns {unknown|undefined|string}
 */
function getCombinationKeyMuscleUtil (props = {}) {
  const {
    muscles,
    shouldNotDefaultToFullBody
  } = props

  if (!Array.isArray(muscles)) {
    return shouldNotDefaultToFullBody
      ? undefined
      : 'FULL_BODY'
  }

  if (
    muscles.length === 1
  ) {
    return
  }

  const muscleCombinationKeys = Object.keys(MUSCLE_COMBINATIONS)
  const muscleCombinationKeysThatMatch = muscleCombinationKeys.filter(
    key => {
      const muscleCombination = MUSCLE_COMBINATIONS[key]
      const intersectionArr = intersectionArrayUtil(muscleCombination, muscles)
      return intersectionArr.length === muscles.length
    }
  )

  let muscleCombinationKeysToCheck = muscleCombinationKeysThatMatch
  if (!muscleCombinationKeysThatMatch?.length) {
    muscleCombinationKeysToCheck = muscleCombinationKeys
  }

  const keyToMuscleIntersectionRatio = {}
  const muscleCombinationKey = sortByArrayUtil(
    muscleCombinationKeysToCheck,
    key => {
      const muscleCombination = MUSCLE_COMBINATIONS[key]
      const musclesIntersectionArr = intersectionArrayUtil(muscleCombination, muscles)
      const musclesIntersectionRatio = (
        musclesIntersectionArr.length / muscleCombination.length
      )
      keyToMuscleIntersectionRatio[key] = musclesIntersectionRatio
      return musclesIntersectionRatio * -1
    }
  )
    .filter(key => {
      return keyToMuscleIntersectionRatio[key] > MIN_MUSCLE_INTERSECTION_RATIO
    })[0]

  if (muscleCombinationKey) {
    return muscleCombinationKey
  }

  return shouldNotDefaultToFullBody
    ? undefined
    : 'FULL_BODY'
}

export { getCombinationKeyMuscleUtil }
